import React from 'react';
import { Translation } from "react-i18next";
import Slider from "react-slick";
import Image from "../../components/image";
import { asset } from '../../helpers/dom.helper';
import styles from './customer.module.scss';

const sliderSettings = {
  dots: true,
  arrows: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
}

export class CustomerReview extends React.PureComponent {

  render() {
    return (
      <Translation ns={['translation', 'customer']}>
        {t => (
          <div className={styles.customerReview}>
            <div className="partner">
              <h1>{t("customer:Our Partners")}</h1>
              <div className="project-management">
                <Slider {...sliderSettings} slidesToShow={6} slidesToScroll={6}>
                  {/* Property */}
                  {/* Slide 1 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/stms.webp')}
                      alt="stms" style={{ backgroundColor: 'green' }} />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/prime.webp')}
                      alt="prime" />
                  </div>
                  {/* <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/prime-estate.webp')}
                      alt="prime estate" />
                  </div> */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/proactive.webp')}
                      alt="proactive" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/pmc.webp')}
                      alt="pmc" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/cbm.webp')}
                      alt="cbm" />
                  </div>

                  {/* Slide-2 */}
                  {/* <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/gk-property.webp')}
                      alt="gk property" />
                  </div> */}

                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/first-pacific.webp')}
                      alt="first pacific" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/define-rama.webp')}
                      alt="define-rama" />
                  </div>

                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/infinite.webp')}
                      alt="infinite" />
                  </div>

                  {/* Slide 3 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/ns-service.webp')}
                      alt="ns-service" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/smart-group.webp')}
                      alt="smart-group" />
                  </div>
                  {/* <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/nsr.webp')}
                      alt="nsr" />
                  </div> */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/power-city.webp')}
                      alt="power-city" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/pkk.webp')}
                      alt="pkk" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/all-license.webp')}
                      alt="all-license" />
                  </div>

                  {/* Slide 4 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/vertiplus.webp')}
                      alt="vertiplus" />
                  </div>
                  {/* <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/jsp-property.webp')}
                      alt="jsp-property" />
                  </div> */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/rsm.webp')}
                      alt="rsm" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/true-property.webp')}
                      alt="true-property" />
                  </div>
                  {/* <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/haus-property.webp')}
                      alt="haus property" />
                  </div> */}

                  {/* Slide 5 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/ocean.webp')}
                      alt="ocean" />
                  </div>
                  <div className="logo-partner">
                    <Image className="d-block " src={asset('/images/about/project-icon/property/peak.webp')}
                      alt="peak" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/bm-group.webp')}
                      alt="bm group" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/billion.webp')}
                      alt="billion" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/bless_asset.webp')}
                      alt="bless asset" />
                  </div>

                  {/* Slide 6 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/hc.webp')}
                      alt="hc" />
                  </div>
                  <div className="logo-partner">
                    <Image className="d-block " src={asset('/images/about/project-icon/property/kac.webp')}
                      alt="kac" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/logo_fast.webp')}
                      alt="fast" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/logo-victory.webp')}
                      alt="victory" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/m2p.webp')}
                      alt="m2p" />
                  </div>

                  {/* Slide 7 */}
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/pls.webp')}
                      alt="pls" />
                  </div>
                  <div className="logo-partner">
                    <Image className="d-block " src={asset('/images/about/project-icon/property/reals-logo.webp')}
                      alt="real s" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/savills.webp')}
                      alt="savills" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/sena-j.webp')}
                      alt="sena-j" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/smc.webp')}
                      alt="smc" />
                  </div>
                  <div className="logo-partner">
                    <Image src={asset('/images/about/project-icon/property/swl.webp')}
                      alt="swl" />
                  </div>

                  
                </Slider>
              </div>
            </div>

            <div className="customer">
              <h1>{t("customer:Our Clients")}</h1>
              {/* Project */}
              <div className="project-site">
                <Slider {...sliderSettings} slidesToShow={3} slidesToScroll={3} rows={2} slidesPerRow={2}>
                  {/* Slide 1 */}
                  <div className="border-icon">
                    <Image alt="333riverside"
                      src={asset('/images/about/project-icon/project/333riverside.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="api-condominium"
                      src={asset('/images/about/project-icon/project/api-condominium.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ashton-asoke"
                      src={asset('/images/about/project-icon/project/ashton-asoke.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ashton-chula"
                      src={asset('/images/about/project-icon/project/ashton-chula.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="aspace-ef"
                      src={asset('/images/about/project-icon/project/aspace-ef.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="aspire-48"
                      src={asset('/images/about/project-icon/project/aspire-48.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="aspre-rama4"
                      src={asset('/images/about/project-icon/project/aspre-rama4.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="attitude-bu"
                      src={asset('/images/about/project-icon/project/attitude-bu.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="sirisquare"
                      src={asset('/images/about/project-icon/project/sirisquare.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="baan-prueksasiri"
                      src={asset('/images/about/project-icon/project/baan-prueksasiri.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ban-phrom-phat"
                      src={asset('/images/about/project-icon/project/ban-phrom-phat-2.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ban-prueksa"
                      src={asset('/images/about/project-icon/project/ban-prueksa.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ban-term-ruk"
                      src={asset('/images/about/project-icon/project/ban-term-ruk.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="baycliff"
                      src={asset('/images/about/project-icon/project/baycliff.webp')} />
                  </div>

                  {/* Slide 2 */}
                  <div className="border-icon">
                    <Image alt="bee-condo"
                      src={asset('/images/about/project-icon/project/bee-condo.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="bhrt"
                      src={asset('/images/about/project-icon/project/bhrt.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="biz-home"
                      src={asset('/images/about/project-icon/project/biz-home.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="boulevard"
                      src={asset('/images/about/project-icon/project/boulevard.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="capital"
                      src={asset('/images/about/project-icon/project/capital.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="casa-rayong"
                      src={asset('/images/about/project-icon/project/casa-rayong.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="casa-ville-sriracha"
                      src={asset('/images/about/project-icon/project/casa-ville-sriracha.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="casa-ville"
                      src={asset('/images/about/project-icon/project/casa-ville.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="cc-condominium"
                      src={asset('/images/about/project-icon/project/cc-condominium.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="censiri"
                      src={asset('/images/about/project-icon/project/censiri.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="centric"
                      src={asset('/images/about/project-icon/project/centric.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="centro-bangna"
                      src={asset('/images/about/project-icon/project/centro-bangna.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="chic-condominium"
                      src={asset('/images/about/project-icon/project/chic-condominium.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="chic-condominium-re"
                      src={asset('/images/about/project-icon/project/chic-condominium-re.webp')} />
                  </div>

                  {/* Slide 3 */}
                  <div className="border-icon">
                    <Image alt="chic-condominium-re2"
                      src={asset('/images/about/project-icon/project/chic-condominium-re2.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="condo-mee-suk"
                      src={asset('/images/about/project-icon/project/condo-mee-suk.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="d-mark-condo"
                      src={asset('/images/about/project-icon/project/d-mark-condo.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="domus"
                      src={asset('/images/about/project-icon/project/domus.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="family-complex"
                      src={asset('/images/about/project-icon/project/family-complex.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="formosa"
                      src={asset('/images/about/project-icon/project/formosa.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="galapapruek-lake-view"
                      src={asset('/images/about/project-icon/project/galapapruek-lake-view.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="galapapruek"
                      src={asset('/images/about/project-icon/project/galapapruek.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="gusto"
                      src={asset('/images/about/project-icon/project/gusto.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="habitown"
                      src={asset('/images/about/project-icon/project/habitown.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="hi-ladprao131"
                      src={asset('/images/about/project-icon/project/hi-ladprao131.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="hi-sukhumvit-93"
                      src={asset('/images/about/project-icon/project/hi-sukhumvit-93.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="hi-sutthisan"
                      src={asset('/images/about/project-icon/project/hi-sutthisan.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="j-village"
                      src={asset('/images/about/project-icon/project/j-village.webp')} />
                  </div>

                  {/* Slide 4 */}
                  <div className="border-icon">
                    <Image alt="jaytiya"
                      src={asset('/images/about/project-icon/project/jaytiya.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="kasa-eureka-rama2"
                      src={asset('/images/about/project-icon/project/kasa-eureka-rama2.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="laddalom-rattanatibet"
                      src={asset('/images/about/project-icon/project/laddalom-rattanatibet.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="lerneo"
                      src={asset('/images/about/project-icon/project/lerneo.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="life-sukhumvit"
                      src={asset('/images/about/project-icon/project/life-sukhumvit.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="manthana-pinkao"
                      src={asset('/images/about/project-icon/project/manthana-pinkao.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="menam-residences"
                      src={asset('/images/about/project-icon/project/menam-residences.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="metrosky"
                      src={asset('/images/about/project-icon/project/metrosky.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="midst-rama9"
                      src={asset('/images/about/project-icon/project/midst-rama9.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="navyhouse"
                      src={asset('/images/about/project-icon/project/navyhouse.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="niruncity"
                      src={asset('/images/about/project-icon/project/niruncity.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="nishmono"
                      src={asset('/images/about/project-icon/project/nishmono.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="north-8-chiangmai"
                      src={asset('/images/about/project-icon/project/north-8-chiangmai.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="nusasiri"
                      src={asset('/images/about/project-icon/project/nusasiri.webp')} />
                  </div>

                  {/* Slide 5 */}
                  <div className="border-icon">
                    <Image alt="oneplus-5"
                      src={asset('/images/about/project-icon/project/oneplus-5.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="onthepond"
                      src={asset('/images/about/project-icon/project/onthepond.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="panapark12"
                      src={asset('/images/about/project-icon/project/panapark12.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pano-ville"
                      src={asset('/images/about/project-icon/project/pano-ville.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="park-village"
                      src={asset('/images/about/project-icon/project/park-village.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pg-rama-9"
                      src={asset('/images/about/project-icon/project/pg-rama-9.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="phuketnewmart"
                      src={asset('/images/about/project-icon/project/phuketnewmart.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="pleno"
                      src={asset('/images/about/project-icon/project/pleno.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="privacy-9"
                      src={asset('/images/about/project-icon/project/privacy-9.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pruksavillage-23"
                      src={asset('/images/about/project-icon/project/pruksavillage-23.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pruksaville-74"
                      src={asset('/images/about/project-icon/project/pruksaville-74.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pruksaville"
                      src={asset('/images/about/project-icon/project/pruksaville.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="pss2"
                      src={asset('/images/about/project-icon/project/pss2.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="quartier"
                      src={asset('/images/about/project-icon/project/quartier.webp')} />
                  </div>

                  {/* Slide 6 */}
                  <div className="border-icon">
                    <Image alt="regenthome-bangson"
                      src={asset('/images/about/project-icon/project/regenthome-bangson.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="regenthome-tiwanon"
                      src={asset('/images/about/project-icon/project/regenthome-tiwanon.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="regenthome"
                      src={asset('/images/about/project-icon/project/regenthome.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="ricco-town"
                      src={asset('/images/about/project-icon/project/ricco-town.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="royal-river"
                      src={asset('/images/about/project-icon/project/royal-river.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="s9"
                      src={asset('/images/about/project-icon/project/s9.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="saiyuan-buri"
                      src={asset('/images/about/project-icon/project/saiyuan-buri.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="shuan-chom-rut"
                      src={asset('/images/about/project-icon/project/shuan-chom-rut.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="sirinestate"
                      src={asset('/images/about/project-icon/project/sirinestate.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="siriraj"
                      src={asset('/images/about/project-icon/project/siriraj.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="six-nature-watcharapol"
                      src={asset('/images/about/project-icon/project/six-nature-watcharapol.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="sub-rung-rueng"
                      src={asset('/images/about/project-icon/project/sub-rung-rueng.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="supalai-asoke"
                      src={asset('/images/about/project-icon/project/supalai-asoke.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="supalai-veranda"
                      src={asset('/images/about/project-icon/project/supalai-veranda.webp')} />
                  </div>

                  {/* Slide 7 */}
                  <div className="border-icon">
                    <Image alt="supicha-koh-kaew"
                      src={asset('/images/about/project-icon/project/supicha-koh-kaew.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="tara-pinkao"
                      src={asset('/images/about/project-icon/project/tara-pinkao.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="teak-39"
                      src={asset('/images/about/project-icon/project/teak-39.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="thana-astoria"
                      src={asset('/images/about/project-icon/project/thana-astoria.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-colors"
                      src={asset('/images/about/project-icon/project/the-colors.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-connect-20"
                      src={asset('/images/about/project-icon/project/the-connect-20.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-grand-pattaya"
                      src={asset('/images/about/project-icon/project/the-grand-pattaya.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="the-green-city-a"
                      src={asset('/images/about/project-icon/project/the-green-city-a.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-nest"
                      src={asset('/images/about/project-icon/project/the-nest.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-next-condo"
                      src={asset('/images/about/project-icon/project/the-next-condo.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-proud"
                      src={asset('/images/about/project-icon/project/the-proud.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-quartier"
                      src={asset('/images/about/project-icon/project/the-quartier.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-rich-nana"
                      src={asset('/images/about/project-icon/project/the-rich-nana.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-rich-taopoon"
                      src={asset('/images/about/project-icon/project/the-rich-taopoon.webp')} />
                  </div>

                  {/* Slice 8 */}
                  <div className="border-icon">
                    <Image alt="the-siam"
                      src={asset('/images/about/project-icon/project/the-siam.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-trust-townhome"
                      src={asset('/images/about/project-icon/project/the-trust-townhome.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-unique"
                      src={asset('/images/about/project-icon/project/the-unique.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="the-win"
                      src={asset('/images/about/project-icon/project/the-win.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="thecube"
                      src={asset('/images/about/project-icon/project/thecube.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="tree-boutiques"
                      src={asset('/images/about/project-icon/project/tree-boutiques.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="treerio"
                      src={asset('/images/about/project-icon/project/treerio.webp')} />
                  </div>

                  <div className="border-icon">
                    <Image alt="tub-tong"
                      src={asset('/images/about/project-icon/project/tub-tong.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="villagepark"
                      src={asset('/images/about/project-icon/project/villagepark.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="von-napa"
                      src={asset('/images/about/project-icon/project/von-napa.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="wind"
                      src={asset('/images/about/project-icon/project/wind.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="windmill"
                      src={asset('/images/about/project-icon/project/windmill.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="z-zenith-place"
                      src={asset('/images/about/project-icon/project/z-zenith-place.webp')} />
                  </div>
                  <div className="border-icon">
                    <Image alt="zenmura"
                      src={asset('/images/about/project-icon/project/zenmura.webp')} />
                  </div>
                </Slider>
              </div>
            </div>
          </div>
        )}
      </Translation>
    )
  }

}